module.exports = __webpack_public_path__ + "img/close.a4774b7c.svg";